export default "__VITE_ASSET__BV$$hjoL__"